module.exports = __webpack_public_path__ + "dash_20_app_assets/img/target.842fe7d4.png";